module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“Name?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Charles Dean.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Middle name?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aloysius.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Real")]), _vm._v(" middle name?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean pursed his lips, hesitating to answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you think this is hard,” said the man in the black business suit near the door, “just wait.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My middle name is Martin,” Dean said. “Charles Martin Dean.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The technicians sitting in front of him nodded. Dean sat on an uncomfortable wooden chair in his undershirt. A web of thin wires ran from sensors taped to his chest, back, neck, and both arms. A headband held larger arrays of sensors to both temples. He felt like an actor in a ’50s Disney movie, transferring his consciousness to a chimp.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Or maybe Mr. Black Suit by the door. Same difference.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Place of birth?” asked one of the technicians.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bosco, Missouri. Population 643, not counting the cows.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It would be better if you answered the questions simply,” said the technician on the right. “The process is automated, and anything the machine can’t interpret will be held against you.”")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let him ramble,” said Black Suit. “We’ve got nowhere to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean started to fold his arms to his chest before remembering the attachments. He put his palms on his thighs instead, willing himself into something approaching patience while the techies continued with their questioning. As Black Suit had hinted, this wasn’t the actual interview; all the technicians were doing was calibrating their elaborate lie detectors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It took them nearly forty minutes to do so. When they were done, Dean asked for a break to hit the head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not now,” said Black Suit. “You’re a Marine. Cross your legs.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Three hours later, Dean’s bladder had displaced his lungs and was working its way toward his throat. It gave him a bit of an edge on the questions about his sexual relationships and carried him through the little game Black Suit and the head-shrink played, peppering him with accusations about how he must really consider himself a failure. But it started to become painful when they began asking him detailed questions about his belief in God.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean wondered what part religion might play in his assignment as George Hadash’s photographic memory. Hadash hadn’t been particularly profuse in describing what Dean was supposed to do before sending him up here, saying only that he wanted someone he could trust to take a look at something unpleasant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean had met Hadash years before, back when both were considerably younger. As a Marine, Dean had been assigned to accompany a young Pentagon visitor around Da Nang for a few days. Hadash proved to be considerably smarter than most of the suits who came out to look at what Vietnam was all about. He’d also proven himself relatively brave, if somewhat naive, volunteering to go out in the bush with Dean. Dean took him—a decision that caused him considerable grief with his commander.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("But it wasn’t like he and Hadash were best of friends. Hadash got in touch with him a few times after the war, once ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("to tell some students over at MIT what the jungle was like. Until yesterday morning, he hadn’t even realized Hadash was the country’s National Security Director.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can take a break, Corporal Dean,” said Black Suit finally.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, real funny,” said Dean, who had left the Marines as a gunnery sergeant, not a corporal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Black Suit smiled—the first time he had for the entire session. “Actually, I thought you might finally pee in your pants.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll tell you something truthful. When I was a corporal, that was probably the best time of my life,” said Dean as they unhooked him from the machine. “I should have refused the promotion.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean was taken down the hallway, flanked by two men who accompanied him into the men’s room. They said it was impossible to go anywhere here without an escort, and under no circumstances to lose his badge with its “V” insignia—someone without a badge might very well be shot. He thought they might be exaggerating, but he didn’t intend on testing it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean hadn’t volunteered to help Hadash, exactly. Hadash simply called and told him he had a job he needed done immediately. He just assumed—just "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("knew")]), _vm._v("—that Dean would drop everything and do it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Dean, for reasons that included $2 million in a Swiss bank account, agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bladder finally relieved, he emerged from the men’s room feeling invigorated. He girded himself for the second round of questions as he entered the room, but the shrink and technicians had left. Only Black Suit remained. He looked at the guards and lifted his forefinger. They nodded like a pair of matched robots, then backed through the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dinnertime?” Dean sat in the wooden chair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This where you slap me around a bit, ask if I’m going to come clean?” Dean asked. “Or do you toss down a pack of cigarettes and offer to split the loot if I talk?”")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re a real funny guy, Sergeant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You know what? I’m not a Marine anymore.” Dean stopped himself from saying that he didn’t really care to be reminded of his days in the service; no sense giving the guy a stick to hit him with. “I’m guessing you were in the Army. I can tell you weren’t a Marine. And you were an officer. Maybe you still are. A major, right? They always had something up their butts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Black Suit smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean stretched his legs and wrapped his arms across his chest, starting to feel a little cold in his T-shirt. “So all right, you asking me more questions or what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re done.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Same time tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. You’re on the job, starting now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You mean I’m hired?” said Dean sardonically as he got up from the chair. “We going to go meet the boss?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t have time to meet anyone,” smirked Black Suit. “You have a plane to catch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where am I going?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Eventually, to Surgut.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Surgut?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re a businessman. Your passport and luggage are waiting for you in the foyer upstairs. Your driver will take you to the airport.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where the hell is Surgut?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t ask questions. Just follow the program.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Surgut,” Dean demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s in Siberia. But don’t worry; it’s not the really bad part of Siberia.”")])])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page30"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85d39744","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429954730_ch03.vue
// module id = 78
// module chunks = 0